/* eslint-disable graphql/template-strings */
import { gql } from '@apollo/client';

export const EDIT_STORE = gql`
  mutation EditStore($input: StoreEditInput!) {
    editStore(input: $input) {
      store {
        id
        isOnboarded
        storeDetails {
          id
          storeName
          avatarURL
          bio
          description
          signUpFlow
          bitcoinReceivingAddress
        }
      }
    }
  }
`;

export const UPLOAD_STORE_IMAGE = gql`
  mutation UploadStoreImage($input: StoreImageInput!) {
    uploadStoreImage(input: $input) {
      id
      avatarURL
    }
  }
`;

export const UPLOAD_STORE_COVER = gql`
  mutation UploadStoreCover($input: StoreImageInput!) {
    uploadStoreCover(input: $input) {
      id
    }
  }
`;

export const CREATE_VERIFICATION_VIDEO = gql`
  mutation CreateVerificationVideo($input: CreateVerificationVideoInput!) {
    createVerificationVideo(input: $input) {
      id
    }
  }
`;

export const CREATE_STORE_TIP = gql`
  mutation CreateUserTip($input: UserTipCreateInput!) {
    createUserTip(input: $input) {
      id
      stripeIntentClientSecret
      message
      amount
    }
  }
`;

export const CREATE_STREAM_TIP = gql`
  mutation CreateStreamTip($input: StreamTipCreateInput!) {
    createStreamTip(input: $input) {
      stripeIntentClientSecret
      message
      amount
    }
  }
`;

export const CREATE_USER_TIP_BITCOIN = gql`
  mutation CreateUserTipBitcoin($input: UserTipBitcoinCreateInput!) {
    createUserTipBitcoin(input: $input) {
      id
      message
      amount
      payment {
        ... on CryptoPayment {
          bitcoinInvoiceUrl
          bitcoinInvoiceId
        }
      }
    }
  }
`;

export const CREATE_STREAM_TIP_BITCOIN = gql`
  mutation CreateStreamTipBitcoin($input: StreamTipBitcoinCreateInput!) {
    createStreamTipBitcoin(input: $input) {
      id
      message
      amount
      payment {
        ... on CryptoPayment {
          bitcoinInvoiceUrl
          bitcoinInvoiceId
        }
      }
    }
  }
`;

export const TRACK_SHARE = gql`
  mutation TrackShare($input: TrackShareInput!) {
    trackShare(input: $input)
  }
`;
